<div class="market-pairs  position-relative">
<div class="widget-header">
  <h2 class="heading"*ngIf="isMarketUser" >
    {{"market" | translate}} | {{state}}
    <span *ngIf="tableView === 'favorites'"  class="icons-container">
      <span class="pill pill-default" (click)="setMarketWatchDefault(activeMarketWatch)">
        {{"SetDefault" | translate}}
      </span>
      <i class="fas fa-trash icon-trash" (click)="deleteMarketWatch(activeMarketWatch.MarketWatchID)"  aria-hidden="true"></i>
    </span>
  </h2>
  

  <div class="input-group custom-actions justify-content-between align-items-center">
    <!-- <div class="input-group-prepend">
      <span class="input-group-text" id="inputGroup-sizing-sm" style="border-radius: 2px;"><i class="icon ion-md-search"></i></span>
    </div> -->
    <div style="margin-inline-start: 0px; flex-grow: 2; ">
      <input type="text" class="form-control" style="height: 30px; border-radius: 2px;"
        (keyup)="updateFilter($event)" placeholder="{{'search-bar-text'|translate}}" />
    </div>
    <div style="padding-inline-start:8px;">
      <mat-button-toggle-group *ngIf="tableView == 'favorites'" appearance="legacy" [value]="favView"
        #group="matButtonToggleGroup" (change)="onFavViewChange(group.value)">
        <mat-button-toggle value="grid">
          <mat-icon class="text-muted" style="font-size: 18px;vertical-align: middle">
            grid_view
          </mat-icon>
        </mat-button-toggle>
        <mat-button-toggle value="table">
          <mat-icon class="text-muted" style="font-size: 18px;vertical-align: middle">
            table_rows
          </mat-icon>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div *ngIf="state != null" style="margin-inline-end: 70px;">
      <button [matMenuTriggerFor]="menu" #trig1="matMenuTrigger" *ngIf="isMarketUser"
        [ngClass]="trig1.menuOpen ? 'active':'inActive'" type="button" mat-icon-button>
        <i class="ion-ios-funnel" style="font-size: 18px; "></i>
      </button>
      <button [matMenuTriggerFor]="colMenu" #trig2="matMenuTrigger" [ngClass]="trig2.menuOpen ? 'active':'inActive'"
        type="button" mat-icon-button>
        <i class="ion-md-menu" style="font-size: 18px;"></i>
      </button>
      <mat-menu #menu="matMenu" class="mat-menu-panelcolors">
        <ul class="nav flex-column nav-pills" style="text-align: center" role="tablist">
          <li class="nav-item">
            <a [ngClass]="{'active': state == 'Favorites'}" class="nav-link" data-toggle="pill" (click)="fetchFavs()"
              role="tab" aria-selected="true">
              <mat-icon style="vertical-align: middle; font-size: 21px;">star</mat-icon> Favorites
            </a>
          </li>
          <hr style="background: #6c757d!important; width: 60%;">

          <li class="nav-item">
            <a [ngClass]="{'active': state == 'Most Active'}" class="nav-link" data-toggle="pill"
              (click)="fetchTodayActive()" role="tab" aria-selected="true">
              Most Active
            </a>
          </li>
          <li class="nav-item">
            <a [ngClass]="{'active': state == 'All Market'}" class="nav-link" (click)="fetchCompanies()"
              data-toggle="pill" role="tab" aria-selected="true">All
              Market</a>
          </li>

          <li class="nav-item">
            <a [ngClass]="{'active': state == 'EGX30'}" class="nav-link" (click)="fetchEGX('EGX30')" data-toggle="pill"
              role="tab" aria-selected="false">EGX30</a>
          </li>
          <li class="nav-item">
            <a [ngClass]="{'active': state == 'EGX70'}" class="nav-link" (click)="fetchEGX('EGX70')" data-toggle="pill"
              role="tab" aria-selected="false">
              EGX70
            </a>
          </li>
          <li class="nav-item">
            <a [ngClass]="{'active': state == 'EGX100'}" class="nav-link" (click)="fetchEGX('EGX100')"
              data-toggle="pill" role="tab" aria-selected="false">EGX100</a>
          </li>

          <hr style="background: #6c757d!important; width: 60%;">

          <li class="nav-item">
            <a [ngClass]="{'active': state == 'NOPL'}" class="nav-link" (click)="fetchMarket('NOPL')" data-toggle="pill"
              role="tab" aria-selected="false">Main
              Market</a>
          </li>
          <li class="nav-item">
            <a [ngClass]="{'active': state == 'sme'}" class="nav-link" (click)="fetchMarket('sme')" data-toggle="pill"
              role="tab" aria-selected="false">NileX</a>
          </li>
          <li class="nav-item">
            <a [ngClass]="{'active': state == 'OTC'}" class="nav-link" (click)="fetchMarket('OTC')" data-toggle="pill"
              role="tab" aria-selected="false">OTC</a>
          </li>
          <li class="nav-item">
            <a [ngClass]="{'active': state == 'SAMEDAY'}" class="nav-link" (click)="fetchMarket('SAMEDAY')"
              data-toggle="pill" role="tab" aria-selected="false">Same Day</a>
          </li>
          <li class="nav-item">
            <a [ngClass]="{'active': state == 'D'}" class="nav-link" (click)="fetchMarket('D')" data-toggle="pill"
              role="tab" aria-selected="false">5%
              Limit</a>
          </li>
        </ul>
      </mat-menu>
      <mat-menu #colMenu="matMenu" class="mat-menu-panelcolors">
        <div class="menuu">
          <div style="margin: 11px; text-align: start;">
            <strong>{{"aval-cols" | translate}}</strong>
          </div>
          <div cdkDropList (cdkDropListDropped)="drop($event)" style="margin: 4px">
            <div *ngFor="let col of columns" cdkDrag class="card column-dropdown-bg">
              <div class="card-body form-switch d-flex align-items-center justify-content-between"
                style="padding: 10px; height: 30px;vertical-align: -webkit-baseline-middle ">
                <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="toggle(col, $event)"
                  [checked]="col.isChecked" class="white-dark-smoke" style="margin: 0px !important;">
                  <label [attr.for]="col.name" class="white-dark-smoke" style=" margin: 0px !important;">
                    <mat-icon class="text-muted" style="font-size: 22px;vertical-align: middle ;cursor: grab;">
                      drag_indicator
                    </mat-icon>
                    <span style="font-family: 'Almarai';padding-inline-start: 4px;">{{col.name | translate}}</span>
                  </label>
                </mat-checkbox>
              </div>
            </div>
          </div>
        </div>
      </mat-menu>
    </div>
  </div>
  </div>

  <div class="trades-card pb-1" id="recent-trades" #myWidget style="overflow:scroll">
    <div class="pills-container" *ngIf="tableView == 'favorites'">
      <div *ngFor="let watch of marketWatches" (click)="selectMarketWatchList(watch)"
        [ngClass]="watch.MarketWatchID === activeMarketWatch.MarketWatchID ? 'selected' : ''"
        class="pill">
        {{ watch.MarketWatchName }}
      </div>
    </div>

    <!-- <div class="d-flex justify-content-center" *ngIf="isFavsLoading">
      <div class="spinner-border text-secondary m-5" role="status">
        <span class="sr-only"></span>
      </div>
    <div> -->
    <div>
      <app-market-grid-view *ngIf="tableView=='favorites' && favCompaniesWithUpdates && favView == 'grid'"></app-market-grid-view>
    </div>

    <div *ngIf="tableView=='favorites' && favView != 'grid'">
      <table mat-table matSort [dataSource]="searchCompWithUpdates.data?.length>0 ? searchCompWithUpdates : favCompaniesWithUpdates"
        class="mat-elevation-z8">


        <!-- Reuters Column -->
        <ng-container sticky matColumnDef="Reuters" [style.width]="'15px'">
          <th *matHeaderCellDef mat-sort-header style="padding-inline-start: 20px !important;">
            {{'reuters'|translate}} </th>
          <td mat-cell *matCellDef="let element" class="text-color-theme">
            <div>{{element.Reuters}}
            </div>
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container sticky matColumnDef="{{translate.currentLang=='ar'?'arb_shortname':'eng_shortname'}}">
          <th *matHeaderCellDef mat-sort-header style="padding-inline-start: 20px !important;" class="w-200">
            {{'symbol' | translate}}
          </th>
          <td mat-cell *matCellDef="let element" class="text-color-theme">

            <div class="ellipsis">{{(translate.currentLang=='en')?element.eng_shortname:element.arb_shortname}}</div>
            <span *ngIf="this.accService.quickButton == true" class="position">
              <i *ngIf="isFav(element.SYMBOL_CODE)" (click)="onStarClick($event, element.SYMBOL_CODE)"
              class="fas fa-star text-warning p-0 mx-7"></i>
            <i *ngIf="!isFav(element.SYMBOL_CODE)" (click)="onStarClick($event, element.SYMBOL_CODE)"
              class="fas fa-star mx-7"></i>



              <button class="border-radios bg-success mx-7" (click)="orderBuy(element.SYMBOL_CODE, 0)">B</button>
              <button class="border-radios bg-danger mx-7" (click)="orderBuy(element.SYMBOL_CODE, 1)">S</button>

              <button [routerLink]="'/company-profile/'+element.SYMBOL_CODE+'/'+element.Reuters"
                class="fas fa-chart-line p-1 align-items-center align-self-center border-radios bg-info mx-7"></button>


              <button class="border-radios bg-primary mx-7 px-2 py-0 font" (click)="bidsAsks(element)">i</button>
            </span>
          </td>
        </ng-container>
        <!-- All Column -->
        <ng-container matColumnDef="{{column.prop}}" *ngFor="let column of colsss;let i = index"
          [matColumnDef]="column.prop">
          <th *matHeaderCellDef mat-sort-header> {{column.name | translate}}
          </th>
          <td
        mat-cell
        *matCellDef="let element; let i = index"
        class="text-color-theme text-center"
        [ngClass]="{
          'flash-up': isFlashingIndex(i, column.prop, 'market', 'up'),
          'flash-down': isFlashingIndex(i, column.prop, 'market', 'down')
        }"
      >
        <span *ngIf="isNumber(element[column.prop])" [ngClass]="getColumnClass(column, element[column.prop])">
          {{
            element[column.prop] % 1 == 0
              ? (element[column.prop] | number)
              : (element[column.prop] | number : '1.2-3' : 'en-US')
          }}
          <span *ngIf="column.prop == 'LAST_CHANGE_PRC'">%</span>
          <span *ngIf="getFlashingNumber(i, column.prop) !== null" class="flashing-number">
            ({{ getFlashingNumber(i, column.prop) }})
          </span>
        </span>
            <!-- <span *ngIf="!isNumber(element[column.prop])">{{ element[column.prop] }}</span> -->
            <span *ngIf="!isNumber(element[column.prop])">
              <span *ngIf="column.prop != 'LAST_TRADE_DATE'">{{element[column.prop]}}</span>
              <span *ngIf="column.prop == 'LAST_TRADE_DATE'" class="p-0">{{ element[column.prop] |
                date:'h:mm:ss'}}</span>
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="colss; sticky: true"></tr>
        <tr
        mat-row
        [ngClass]="{
          highlight: selected?.SYMBOL_CODE == element.SYMBOL_CODE,
          suspended: element?.SYMBOL_STATE == 'S'
        }"
        (contextmenu)="onTableContextMenu($event, element)"
        (click)="onSelect(element)"
        *matRowDef="let element; columns: colss"
        class="example-element-row row-border-type1"
      ></tr>
      </table>
    </div>



    <!-- *ngIf="isCompaniesLoading" -->
    <section *ngIf="isCompaniesLoading">
      <mat-progress-bar mode='indeterminate'>
      </mat-progress-bar>
    </section>
<div class="scroll-container">
    <table *ngIf="tableView=='market'" #MatTable mat-table matSort
      [dataSource]="searchCompWithUpdates.data?.length>0 ? searchCompWithUpdates : companiesWithUpdates" class="mat-elevation-z8">

      <!-- Reuters Column -->
      <ng-container sticky matColumnDef="Reuters" [style.width]="'15px'">
        <th *matHeaderCellDef mat-sort-header style="padding-inline-start: 20px !important;">
          {{'reuters'|translate}} </th>
        <td mat-cell *matCellDef="let element" class="text-color-theme">
          <div>{{element.Reuters}}
          </div>
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container sticky matColumnDef="{{translate.currentLang=='ar'?'arb_shortname':'eng_shortname'}}">
        <th *matHeaderCellDef mat-sort-header style="padding-inline-start: 20px !important;" class="w-200">
          {{'symbol' | translate}}
        </th>
        <td mat-cell *matCellDef="let element" class="text-color-theme">
          <div class="ellipsis">{{(translate.currentLang=='en')?element.eng_shortname:element.arb_shortname}}</div>
          <span *ngIf="this.accService.quickButton == true" class="position">

            <i *ngIf="isFav(element.SYMBOL_CODE)" (click)="onStarClick($event, element.SYMBOL_CODE)"
              class="fas fa-star text-warning p-0 mx-7"></i>
            <i *ngIf="!isFav(element.SYMBOL_CODE)" (click)="onStarClick($event, element.SYMBOL_CODE)"
              class="fas fa-star mx-7"></i>

            <!-- <app-favorite-menu *ngIf="dropdownOpen"  [x]="dropdownX" [y]="dropdownY" [isShow]="dropdownOpen" [item]="selectedItem"
              [marketWatches]="marketWatches" (clickedOutside)="closeDropdown()"
              (addNewFavorite)="addFavoriteList($event)" (selectMarketWatchEvent)="handleMarketWatchSelection($event)"
              (deleteMarketWatchEvent)="deleteMarketWatch($event.marketWatchID)">
            </app-favorite-menu> -->

            <button class="border-radios bg-success mx-7" (click)="orderBuy(element.SYMBOL_CODE, 0)">B</button>
            <button class="border-radios bg-danger mx-7" (click)="orderBuy(element.SYMBOL_CODE, 1)">S</button>

            <button [routerLink]="'/company-profile/'+element.SYMBOL_CODE+'/'+element.Reuters"
              class="fas fa-chart-line p-1 align-items-center align-self-center border-radios bg-info mx-7"></button>

            <button class="border-radios bg-primary mx-7 px-2 py-0 font" (click)="bidsAsks(element)">i</button>
          </span>
        </td>
      </ng-container>
      <!-- All Column -->
      <ng-container matColumnDef="{{column.prop}}" *ngFor="let column of colsss;let i = index"
        [matColumnDef]="column.prop">
        <th *matHeaderCellDef mat-sort-header>{{ column.name | translate }}</th>
      <td
  mat-cell
  *matCellDef="let element; let i = index"
  class="text-color-theme text-center"
  [ngClass]="{
    'flash-up': element[column.prop + '_UPDATED'] === 2,
    'flash-down': element[column.prop + '_UPDATED'] === 1,
    'no-change': element[column.prop + '_UPDATED'] === 0
  }"
>
  <span *ngIf="isNumber(element[column.prop])" [ngClass]="getColumnClass(column, element[column.prop])">
    {{
      element[column.prop] % 1 == 0
        ? (element[column.prop] | number)
        : (element[column.prop] | number : '1.2-3' : 'en-US')
    }}
    <span *ngIf="column.prop == 'LAST_CHANGE_PRC'">%</span>
  </span>
          <!-- <span *ngIf="!isNumber(element[column.prop])">{{ element[column.prop] }}</span> -->
          <span *ngIf="!isNumber(element[column.prop])">
            <span *ngIf="column.prop != 'LAST_TRADE_DATE'">{{element[column.prop]}}</span>
            <span *ngIf="column.prop == 'LAST_TRADE_DATE'" class="p-0">{{ element[column.prop] | date:'h:mm:ss'}}</span>
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="colss; sticky: true"></tr>
      <tr
      mat-row
      [ngClass]="{
        highlight: selected?.SYMBOL_CODE == element.SYMBOL_CODE,
        suspended: element?.SYMBOL_STATE == 'S'
      }"
      (contextmenu)="onTableContextMenu($event, element)"
      (click)="onSelect(element)"
      *matRowDef="let element; columns: colss"
      class="example-element-row row-border-type1"
    ></tr>
    </table>
  </div>
    <app-context-menu (clickedOutside)="clickedOutsideMenu()" (addNew)="addWidgett($event)" [item]="addWidgetSymbolCode"
      [isShow]="contextmenu" [x]="contextmenuX" [y]="contextmenuY">
    </app-context-menu>
  </div>
</div>


            <app-favorite-menu [x]="dropdownX" [y]="dropdownY" [isShow]="dropdownOpen" [item]="selectedItem"
               (clickedOutside)="closeDropdown()"
              (addNewFavorite)="addFavoriteList($event)" (selectMarketWatchEvent)="handleMarketWatchSelection($event)"
              (deleteMarketWatchEvent)="deleteMarketWatch($event.marketWatchID)">
            </app-favorite-menu>